import React, { useState , useEffect } from "react";
import { Input } from "antd";
import type { InputRef } from "antd";

interface OtpInputProps {
  length: number;
  onComplete: (otp: string) => void;
  className?: string;
  reset: boolean;
}

const OtpInput: React.FC<OtpInputProps> = ({ length, onComplete, className, reset }) => {

  useEffect(() => {
    if (reset) {
      setOtp(Array(length).fill(""));
    }
  }, [reset]);

  const [otp, setOtp] = useState<string[]>(Array(length).fill(""));
  const inputsRef = React.useRef<InputRef[]>([]);

  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    onComplete(newOtp.join(""));

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, length);
    if (!/^\d*$/.test(pasteData)) return;

    const newOtp = [...otp];
    for (let i = 0; i < pasteData.length; i++) {
      newOtp[i] = pasteData[i];
    }
    setOtp(newOtp);
    onComplete(newOtp.join(""));

    const lastFilledIndex = pasteData.length - 1;
    if (lastFilledIndex < length) {
      inputsRef.current[lastFilledIndex]?.focus();
    }
  };

  return (
    <div className={`flex justify-center items-center gap-2 ${className}`}>
      {Array(length)
        .fill(0)
        .map((_, index) => (
          <Input
            key={index}
            ref={(el) => (inputsRef.current[index] = el!)}
            value={otp[index]}
            maxLength={1}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={index === 0 ? handlePaste : undefined}
            className="w-12 h-12 text-center text-lg font-semibold border border-primary rounded-md"
          />
        ))}
    </div>
  );
};

export default OtpInput;
